import React from 'react';
import AuthCard from 'features/Auth/AuthCard/AuthCard.wrapper';
import StepperForm from '@components/FormFields/StepperForm/StepperForm.component';
import PasswordCard from 'features/Auth/Register/PasswordCard/PasswordCard.component';
import RegisterCard from 'features/Auth/Register/RegisterCard/RegisterCard.component';
import { useNavigate } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

interface RegisterData {
  firstName: string;
  lastName: string;
  userName?: string;
  email: string;
  password: string;
}

// Frontend validation commented out - using API validation instead
// export const validateRegister = (values: any) => {
//   const errors: any = {};
//   if (!values.firstName) {
//     errors.firstName = 'Required';
//   }
//   if (!values.lastName) {
//     errors.lastName = 'Required';
//   }
//   if (!values.email) {
//     errors.email = 'Required';
//   }
//   return errors;
// };

// export const validatePassword = (values: any) => {
//   const errors: any = {};
//   if (!values.password) {
//     errors.password = 'Required';
//   }
//   if (!values.confirmPassword) {
//     errors.confirmPassword = 'Required';
//   }
//   return errors;
// };

const Register = () => {
  const navigate = useNavigate();

  const registerMutation = useMutation({
    mutationFn: async (data: RegisterData) => {
      const response = await axios.post('https://interviewer.runasp.net/api/users/register-basic-user', {
        firstName: data.firstName,
        lastName: data.lastName,
        userName: data.userName,
        email: data.email,
        password: data.password
      });
      return response.data;
    },
    onSuccess: (_, variables) => {
      navigate({
        to: '/confirm-email',
        state: { email: variables.email } as any,
      });
    },
    onError: (error) => {
      console.error('Registration error:', error);
    },
  });

  const handleSubmit = (values: any) => {
    registerMutation.mutate(values as RegisterData);
  };

  const getErrorMessage = () => {
    return registerMutation.error?.response?.data?.title || null;
  };

  return (
    <AuthCard sx={{ height: '766px' }}>
      <StepperForm
        steps={[
          {
            label: 'Register',
            component: <RegisterCard />,
            validate: () => ({}),
          },
          {
            label: 'Password',
            component: <PasswordCard errorMessage={getErrorMessage()} />,
            validate: () => ({}),
          },
        ]}
        onSubmit={handleSubmit}
      />
    </AuthCard>
  );
};

export default Register;
